import { customFetch } from 'utils/http';
import { UnexpectedError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idUser: number;
  newEmail: string;
};

export const setUserEmail = async (params: Params) => {
  const { idUser, newEmail } = params;

  const body = new FormData();

  body.append('idUser', `${idUser}`);
  body.append('newEmail', newEmail);

  const response = await customFetch(getM8AdminURL('setUserEmail'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
